function r(n,e){return!n||typeof n!="string"?"":n.length<=e?n:n.slice(0,e)+"..."}export{r as a};
